// The id Forms sends as X-Request-ID on every call to Logyx core (apiService.ts).
// Logyx core takes a client's id when it matches `^[A-Za-z0-9._:-]{1,64}$`
// (logix-core flask_app/ordering/keys.py). It logs it on its access lines,
// stores it on an order's send as `client_request_id`, and echoes it. So a
// Sentry event that names it (lostAnswerCapture.ts) leads to core's lines and
// to the order. The prefix tells it apart from erp's and core's own ids, which
// are 32 hex characters too.
export const REQUEST_ID_HEADER = 'X-Request-ID';

const HEX_32 = /^[0-9a-f]{32}$/;

// 32 lowercase hex characters. `crypto.randomUUID` is missing on an http origin
// (it needs a secure context) and in jest's jsdom; Math.random is enough there,
// as the id only has to tell requests apart.
const randomHex = (): string => {
  const uuid = globalThis.crypto?.randomUUID?.();
  const hex = typeof uuid === 'string' ? uuid.replace(/-/g, '') : '';
  if (HEX_32.test(hex)) {
    return hex;
  }
  let fallback = '';
  while (fallback.length < 32) {
    fallback += Math.floor(Math.random() * 16).toString(16);
  }
  return fallback;
};

export const newRequestId = (): string => `forms-${randomHex()}`;
